import * as React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import "./partners.css"

const pricingData = [
  { placement: "Full Page", once: "$1500", yearly: "$1250", twoYear: "$1000" },
  { placement: "1/2 Page", once: "$800", yearly: "$650", twoYear: "$500" },
  { placement: "1/3 Page", once: "$750", yearly: "$550", twoYear: "$400" },
  { placement: "1/4 Page", once: "$500", yearly: "$450", twoYear: "$350" },
  { placement: "1/6 Page", once: "$400", yearly: "$325", twoYear: "$250" },
  { placement: "1/8 Page", once: "$350", yearly: "$300", twoYear: "$200" },
  { placement: "1/15 Page", once: "$200", yearly: "$150", twoYear: "$100" },
  { placement: "1/24 Page", once: "$80", yearly: "$65", twoYear: "$40" },
  { placement: "Email Blast", once: "$500", yearly: "$450", twoYear: "$350" }
]

const pricingTiers = [
  {
    name: "Starter",
    price: "$200",
    period: "per month",
    description: "Perfect for local fishing shops and small businesses",
    popular: false,
    features: [
      "1/15 Page Advertisement",
      "Monthly placement",
      "21,800+ readers reach"
    ],
    cta: "Start Small"
  },
  {
    name: "Professional", 
    price: "$800",
    period: "per month",
    description: "Ideal for established fishing gear companies",
    popular: true,
    features: [
      "1/2 Page Advertisement",
      "Monthly placement",
      "21,800+ readers reach",
      "Custom ad design consultation",
      "Social media mentions"
    ],
    cta: "Most Popular"
  },
  {
    name: "Enterprise",
    price: "$1,500", 
    period: "per month",
    description: "For major brands and fishing industry leaders",
    popular: false,
    features: [
      "Full Page Advertisement",
      "Monthly placement",
      "21,800+ readers reach"
    ],
    cta: "Go Premium"
  }
]

const stats = [
  { number: "21,800+", label: "Unique Readers" },
  { number: "43+", label: "Years of Trust" },
  { number: "100%", label: "Local Knowledge" }
]

const PartnersPage = () => (
  <Layout>
    <Seo title="Advertising & Partnership Plans" />
    <div className="pricing-page">
      
      {/* Hero Section */}
      <section className="pricing-hero">
        <div className="hero-content">
          <div className="hero-badge">
            <span>🎣 Trusted Since 1982</span>
          </div>
          <h1>Reach passionate anglers with advertising that works</h1>
          
          <div className="hero-content-box">
            <p className="hero-subtitle">
              Join industry leaders who trust The Fish Sniffer to connect with California's 
              most dedicated fishing community. Choose the plan that fits your goals.
            </p>
            <div className="hero-stats">
              {stats.map((stat, index) => (
                <div key={index} className="stat-item">
                  <div className="stat-number">{stat.number}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Container for all content */}
      <div className="content-container">
        
        {/* Pricing Tiers - Moved to top */}
        <section className="pricing-tiers">
          <div className="pricing-header">
            <h2>Popular Advertising Packages</h2>
            <p>Pre-configured plans for different business sizes and marketing goals</p>
          </div>
          
          <div className="tiers-container">
            <div className="tier-wrapper small">
              <div className={`pricing-tier ${pricingTiers[0].popular ? 'popular' : ''}`}>
                <div className="tier-header">
                  <h3 className="tier-name">{pricingTiers[0].name}</h3>
                  <div className="tier-price">
                    <span className="price">{pricingTiers[0].price}</span>
                    <span className="period">{pricingTiers[0].period}</span>
                  </div>
                  <p className="tier-description">{pricingTiers[0].description}</p>
                </div>

                <ul className="tier-features">
                  {pricingTiers[0].features.map((feature, idx) => (
                    <li key={idx}>
                      <svg className="check-icon" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>

                <button 
                  className={`tier-cta ${pricingTiers[0].popular ? 'popular' : ''}`}
                  onClick={() => document.getElementById('final-cta')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  {pricingTiers[0].cta}
                </button>
              </div>
            </div>

            <div className="tier-wrapper large">
              <div className={`pricing-tier ${pricingTiers[1].popular ? 'popular' : ''}`}>
                {pricingTiers[1].popular && <div className="popular-badge">Most Popular</div>}
                
                <div className="tier-header">
                  <h3 className="tier-name">{pricingTiers[1].name}</h3>
                  <div className="tier-price">
                    <span className="price">{pricingTiers[1].price}</span>
                    <span className="period">{pricingTiers[1].period}</span>
                  </div>
                  <p className="tier-description">{pricingTiers[1].description}</p>
                </div>

                <ul className="tier-features">
                  {pricingTiers[1].features.map((feature, idx) => (
                    <li key={idx}>
                      <svg className="check-icon" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>

                <button 
                  className={`tier-cta ${pricingTiers[1].popular ? 'popular' : ''}`}
                  onClick={() => document.getElementById('final-cta')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  {pricingTiers[1].cta}
                </button>
              </div>
            </div>

            <div className="tier-wrapper small">
              <div className={`pricing-tier ${pricingTiers[2].popular ? 'popular' : ''}`}>
                <div className="tier-header">
                  <h3 className="tier-name">{pricingTiers[2].name}</h3>
                  <div className="tier-price">
                    <span className="price">{pricingTiers[2].price}</span>
                    <span className="period">{pricingTiers[2].period}</span>
                  </div>
                  <p className="tier-description">{pricingTiers[2].description}</p>
                </div>

                <ul className="tier-features">
                  {pricingTiers[2].features.map((feature, idx) => (
                    <li key={idx}>
                      <svg className="check-icon" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>

                <button 
                  className={`tier-cta ${pricingTiers[2].popular ? 'popular' : ''}`}
                  onClick={() => document.getElementById('final-cta')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  {pricingTiers[2].cta}
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Complete Pricing Grid - Moved below tiers */}
        <section className="complete-pricing-section">
          <div className="pricing-grid-header">
            <h2>Complete Digital Magazine Advertising Rates</h2>
            <p>All placements include digital magazine distribution to 21,800+ engaged readers</p>
          </div>
          
          <div className="pricing-grid-container">
            <table className="modern-pricing-table">
              <thead>
                <tr>
                  <th>Placement Size</th>
                  <th>1x (1 Month)</th>
                  <th>12x (1 Year)</th>
                  <th>24x (2 Years)</th>
                </tr>
              </thead>
              <tbody>
                {pricingData.map((row) => (
                  <tr key={row.placement}>
                    <td className="placement-name">{row.placement}</td>
                    <td className="price-cell">{row.once}</td>
                    <td className="price-cell highlighted">{row.yearly}</td>
                    <td className="price-cell best-value">{row.twoYear}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
                    {/* Full Platform Advertising - Professional Redesign */}
          <section className="platform-advertising">
            <div className="platform-container">
              {/* Hero Section */}
              <div className="platform-hero">
                <div className="platform-badge">🚀 Supercharge Your Campaign</div>
                <h2 className="platform-title">Dominate Every Channel</h2>
                <p className="platform-description">Turn casual browsers into loyal customers across our entire digital ecosystem</p>
                
                <div className="platform-pricing">
                  <div className="price-main">
                    <span className="price-currency">+</span>
                    <span className="price-amount">99</span>
                    <span className="price-period">/month</span>
                  </div>
                  <p className="price-note">Add to any magazine plan</p>
                </div>
              </div>

              {/* Stats Row */}
              <div className="platform-stats">
                <div className="stat-item">
                  <span className="stat-icon">📊</span>
                  <span className="stat-number">4x</span>
                  <span className="stat-label">More Touchpoints</span>
                </div>
                <div className="stat-divider"></div>
                <div className="stat-item">
                  <span className="stat-icon">🧠</span>
                  <span className="stat-number">85%</span>
                  <span className="stat-label">Higher Recall</span>
                </div>
                <div className="stat-divider"></div>
                <div className="stat-item">
                  <span className="stat-icon">📈</span>
                  <span className="stat-number">3.2x</span>
                  <span className="stat-label">Conversion Lift</span>
                </div>
              </div>

              {/* Coverage Areas */}
              <div className="platform-coverage">
                <h3 className="coverage-title">Your ads will appear across</h3>
                <div className="coverage-list">
                  <div className="coverage-item">
                    <span className="coverage-icon">🌊</span>
                    <div className="coverage-content">
                      <h4>Freshwater Reports</h4>
                      <p>Lake, river, and stream fishing coverage</p>
                    </div>
                  </div>
                  <div className="coverage-item">
                    <span className="coverage-icon">🏖️</span>
                    <div className="coverage-content">
                      <h4>Saltwater Reports</h4>
                      <p>Ocean, bay, and coastal fishing coverage</p>
                    </div>
                  </div>
                  <div className="coverage-item">
                    <span className="coverage-icon">🌿</span>
                    <div className="coverage-content">
                      <h4>Conservation Reports</h4>
                      <p>Environmental and sustainability content</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="platform-action">
                <button 
                  className="platform-btn"
                  onClick={() => document.getElementById('final-cta')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  Amplify My Reach
                </button>
              </div>
            </div>
          </section>
        </section>

        {/* Savings Section */}
        <section className="savings-section">
          <div className="savings-content">
            <h2>Save More with Longer Commitments</h2>
            <p>Lock in better rates with annual and bi-annual contracts</p>
            
            <div className="savings-grid">
              <div className="savings-card">
                <div className="savings-badge">Save 15%</div>
                <h3>Annual Contract</h3>
                <p>12-month commitment with quarterly invoicing</p>
                <div className="savings-example">
                  <span>Full Page: <strong>$1,250/month</strong></span>
                  <span className="original-price">was $1,500</span>
                </div>
              </div>
              
              <div className="savings-card featured">
                <div className="savings-badge best">Save 30%</div>
                <h3>24-Month Contract</h3>
                <p>Maximum savings with our longest commitment</p>
                <div className="savings-example">
                  <span>Full Page: <strong>$1,000/month</strong></span>
                  <span className="original-price">was $1,500</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section id="final-cta" className="final-cta">
          <div className="cta-content">
            <h2>Ready to Hook Your Perfect Audience?</h2>
            <p>
              Join industry leaders who trust The Fish Sniffer to deliver results. 
              Our team will help you create the perfect campaign for your goals.
            </p>
            <div className="contact-info">
              <p>Call us directly at:</p>
              <p className="phone-number">530-346-8696</p>
              <p>Or email: paulkneeland@fishsniffer.com</p>
            </div>
            <div className="cta-buttons">
              <a href="mailto:paulkneeland@fishsniffer.com" className="cta-primary">
                📧 Email Us
              </a>
              <a href="tel:+15303468696" className="cta-secondary">
                📞 Call Us
              </a>
            </div>
            <div className="cta-guarantee">
              <span>✓ No setup fees</span>
              <span>✓ Custom creative support</span>
              <span>✓ 43+ years of trust</span>
            </div>
          </div>
        </section>


      </div>
    </div>
  </Layout>
)

export default PartnersPage

export const Head = () => <Seo title="Advertising & Partnership Plans" />
